import React, { useContext, useEffect, useMemo } from "react";
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
/* --------------------------------------------- */
import { GlobalContext } from '../../../context/global.context';
/* --------------------------------------------- */
import LandingInfo from './LandingInfo'
import LandingFeature from './LandingFeature'
import GenericSection from './GenericMiddleSection'
import GenericBottomSection from './GenericBottomSection'
// import genericSectionMockImg from '../../../imgs/landing/Rectangle-2673-section.png'
// import genericSectionMock1Img from '../../../imgs/landing/rectangle-3-272.png'
// import genericSectionMock2Img from '../../../imgs/landing/Rectangle-2673-section.png'
import "./_landing-page.scss";
import { getFormattedLandingPageData } from "../../../utils/landingPageUtils";
import useRoutePath from "../../../hooks/useRoutePath";
import OnImagesLoaded from "react-on-images-loaded";

/* --------------------------------------------- */

function LandingPage(props) {
  const { dispatch, isAuthenticated } = useContext(GlobalContext)
  const {landingPageData: [landingPage = {}] = [],landingPageComponentThemes=[]} = useSelector(store => store.featuresReducers.introConfig)
  //const backgroundImages = [genericSectionMockImg, genericSectionMock1Img, genericSectionMock2Img];
  const { components = [] } = landingPage
  const formattedData = useMemo(() => {return getFormattedLandingPageData(components,landingPageComponentThemes)}, [components,landingPageComponentThemes])
  
  useRoutePath();

  useEffect(() => {
    if(formattedData && formattedData.length > 0) {
      setTimeout(() => {
        dispatch({ type: 'SHOW_SPLASH', value: false })
      }, 1500);
    }
  }, [dispatch, formattedData]);
  /* --------------------------------------------- */
  if(isAuthenticated) return <Redirect to='/'/>
  const hideSplash=()=>{
    setTimeout(() => {
      // dispatch({ type: 'SHOW_SPLASH', value: false })      
    }, 1500);
  }
  const landingPageComponentDOM = () => formattedData.map((component, index)=>{
    const {
      type:componentType,
      theme,
      landingPlanData,
      sectionData,
      landingFeaturePointsData,
      featureSectionData,
      faqData,
      channelsData,
      contentsCategoryData,
    } = component;
    if(componentType === 'landing_intro'){
      return (<LandingInfo landingIntro={sectionData} themeSection={theme} key={index} />)
    }
    else if(componentType === 'landing_feature_points'){
      return ( <LandingFeature landingFeature={landingFeaturePointsData} themeSection={theme} key={index} />)
    }
    else if(componentType === 'landing_feature' && featureSectionData && featureSectionData.length){
     return featureSectionData.map((item) => (<GenericSection sectionData={item} themeSection={theme}key={index}/>))
    }
    else if(componentType === 'landing_plan'){
      return ( <GenericBottomSection sectionData={sectionData} contentData={landingPlanData} themeSection={theme} key={index}/>)
    }
    else if(componentType === 'landing_content_category'){
      return (<GenericBottomSection sectionData={sectionData} contentData={contentsCategoryData} themeSection={theme} key={index}/>)
    }
    else if(componentType === 'landing_channels'){
      return (<GenericBottomSection sectionData={sectionData} contentData={channelsData} themeSection={theme} key={index} />)
    }
    else if(componentType === 'landing_faq'){
      return ( <GenericBottomSection sectionData={sectionData} contentData={faqData} themeSection={theme} key={index} /> )
    }
    else return <></>
  })

  return (
    <div>
      {formattedData && (
        <OnImagesLoaded onLoaded={() => hideSplash()} delay={1000} timeout={4000}>
          {landingPageComponentDOM()}
        </OnImagesLoaded>
      )}
    </div>
  );
}
/* --------------------------------------------- */

export default React.memo(LandingPage);
